<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Fleet Manager Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Fleet Manager Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <form @submit.prevent="filterData">
                    <div class="d-flex justify-content-center mt-2 mb-2">
                        <div class="col-xl-4 col-md-4">
                            <label>Start date</label><br/>
                            <input type="date" v-model="reportFilter.start_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>End date</label><br/>
                            <input type="date" v-model="reportFilter.end_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>&nbsp;</label><br/>
                            <button type="submit" class="btn btn-primary">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </form>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-user stat-icon text-primary"></i>
                                <div class="stat-label">Total Fleet Managers</div>
                                <div class="stat-value">{{ total_fleet_managers }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-car stat-icon text-secondary"></i>
                                <div class="stat-label">Total Fleet Vehicles</div>
                                <div class="stat-value">{{ total_vehicles }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 p-3">
                            <h4 class="text-center">Fleet Vehicles ({{ total_vehicles }})</h4>

                            <div class="chart-wrapper mx-auto">
                                <PieChart :chart-data="pieData" :options="pieOptions"/>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="text-center">
                    <b> {{ period }}</b>
                </p>
            </section>
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <div class="col-12">
                            <h5 class="mb-3 font-weight-bold">Top Performing Fleets</h5>
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Fleet Owner</th>
                                            <th>No of trips</th>
                                            <th>No of vehicles</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fleet in top_fleets" class="mb-2 p-3">
                                            <th><a :href="route('admin.fleet_managers.show', fleet.id)">{{ fleet.owner }}</a></th>
                                            <th>{{ fleet.trips_count }}</th>
                                            <th>{{ fleet.vehicles_count }}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/inertia-vue';
import PieChart from "../../Shared/PieChart.vue";
import {Doughnut} from "vue-chartjs/legacy";

export default {
    metaInfo: {title: 'Fleet Manager Reports'},
    props: ['totalFleetManagers', 'totalVehicles', 'vehicleStats', 'topFleets'],
    layout: Layout,
    name: 'FleetManagerReport',
    components: {
        Doughnut,
        PieChart,
        Link,
    },
    mixins: [],
    data: () => ({
        pieOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        reportFilter : {
            start_date: '',
            end_date: ''
        },
        period: '',
        pieData: {
            labels: [],
            datasets: []
        },
        total_vehicles: '',
        total_fleet_managers: '',
        top_fleets: '',
        excelData: {},
    }),
    mounted() {
        let data = this.vehicleStats.data;
        this.period = this.vehicleStats.period;

        const labels = Object.keys(data).map(key => key);
        const values = Object.keys(data).map(key => data[key]);
        const colors =this.pieColor();

        this.pieData = this.pieThumbprint(labels, values, colors);
        this.total_fleet_managers = this.totalFleetManagers
        this.total_vehicles = this.totalVehicles
        this.total_vehicles = this.totalVehicles
        this.top_fleets = this.topFleets
    },

    methods: {
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        async filterData() {
            try {
                let results = await axios.get(route("admin.reports.fleet-managers"), {
                    params: {
                        start_date: this.reportFilter.start_date,
                        end_date: this.reportFilter.end_date,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });


                let data = results.data.vehicleStats.data;

                const labels = Object.keys(data).map(key => key);
                const values = Object.keys(data).map(key => data[key]);
                const colors = this.pieColor();

                this.pieData = this.pieThumbprint(labels, values, colors);
                this.period = results.data.vehicleStats.period
                this.total_fleet_managers = results.data.totalFleetManagers
                this.total_vehicles = results.data.totalVehicles
                this.top_fleets = results.data.topFleets
            } catch (e) {
                console.log(e);
            }
        },

        pieThumbprint(labels, data, backgroundColor) {
            return {
                labels,
                datasets: [
                    {
                        backgroundColor,
                        data
                    }
                ]
            }
        },

        randomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        },

        pieColor() {
            return ['#8E50EB', '#FFA87D'];
        },

        async resetFilter() {
            this.reportFilter = {
                start_date: '',
                end_date: ''
            }

            await this.filterData();
        },
    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Device', 'Total']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                rows.push([key, this.excelData[key]]);
            }

            return rows;
        }
    }
}
</script>
<style>
.chart-wrapper {
    width: 350px;      /* desired width */
    height: 350px;     /* desired height */
    display: flex;
    justify-content: center;
    align-items: center;
}
.chart-wrapper canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
